import { rootApi } from '../rootApi';

// İhale Talebi ekranı — bkz. docs/LMS-IHALE--FE-Dokumani.txt §1. lms.tender_request_t tablosunu
// okur/yazar (eğitim talebi kayıtlarından ayrı bir tablo). Onay akışı (ChangeStatus/GetComments)
// ise eğitim talebiyle ORTAK uçtan (LmsCreateRequest) requestType: 3 ile çağrılıyor — bkz.
// lmsCreateRequest.js'teki changeLmsCreateRequestStatus/getLmsCreateRequestComments.
export const lmsTenderRequestApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsTenderRequests: builder.query({
            query: ({ pageNumber, pageSize, filters, sorts }) => ({
                url: 'v1/LmsTenderRequest/GetList',
                method: 'POST',
                body: {
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10,
                    filters: Array.isArray(filters) ? filters : [],
                    sorts: Array.isArray(sorts) && sorts.length > 0 ? sorts : [{ column: 'CreatedDate', direction: 2 }],
                    includeFilterOptions: false,
                    filterOptionsColumns: null
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsTenderRequest']
        }),

        getLmsTenderRequestById: builder.query({
            query: (id) => ({
                url: 'v1/LmsTenderRequest/GetById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsTenderRequest']
        }),

        addLmsTenderRequest: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTenderRequest/Add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTenderRequest']
        }),

        updateLmsTenderRequest: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTenderRequest/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTenderRequest']
        }),

        deleteLmsTenderRequest: builder.mutation({
            query: (id) => ({
                url: `v1/LmsTenderRequest/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['LmsTenderRequest']
        }),

        // Kayit olusturmadan bitis tarihlerini hesaplar - bkz. docs/LMS-FE-API-Dokumani-Ihale-Date-Tercuman.txt SS3.2.
        // 14 gunluk kural bu ucta uygulanmaz, sadece formda anlik gosterim icin kullanilir.
        calculateLmsTenderRequestEndDate: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTenderRequest/CalculateEndDate',
                method: 'POST',
                body: data || {}
            }),
            transformResponse: (response) => response?.data || response || null
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsTenderRequestsQuery,
    useGetLmsTenderRequestByIdQuery,
    useAddLmsTenderRequestMutation,
    useUpdateLmsTenderRequestMutation,
    useDeleteLmsTenderRequestMutation,
    useCalculateLmsTenderRequestEndDateMutation
} = lmsTenderRequestApi;
